// Versione in esecuzione: scritta nel tag <meta name="app-version"> da deploy.sh a ogni build (assente in sviluppo)
export const getRunningVersion = () => {
    const meta = document.querySelector('meta[name="app-version"]');
    return meta ? meta.getAttribute('content') : null;
};

// Ultima versione pubblicata sul server (version.json, mai in cache)
export const fetchLatestVersion = async () => {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return data.version || null;
};

// Svuota service worker e cache del browser e ricarica la pagina
export const reloadWithFreshAssets = async () => {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((r) => r.unregister()));
        }
        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
        }
    } catch (e) {
        // se la pulizia fallisce si ricarica comunque
    }
    window.location.reload();
};
